import React from 'react';
import { useEventSubjectStyle } from './component.style';

export const EventSubjectContainer = (props) => {
  const classes = useEventSubjectStyle();
  const { eventInfo } = props;

  return <div className={classes.container}>{eventInfo.subject}</div>;
};
